import {POP_QUIZ_PHASE} from '../constants';
import {Phase, PopQuizItem} from '../types';

export interface PopQuizLifecycleState {
    isOpen: boolean;
    phase: Phase;
    questions: PopQuizItem[];
    correctCount: number;
    attemptId: string | undefined;
    stopShowing: boolean;
}

export const initialPopQuizLifecycleState: PopQuizLifecycleState = {
    isOpen: false,
    phase: POP_QUIZ_PHASE.prompt,
    questions: [],
    correctCount: 0,
    attemptId: undefined,
    stopShowing: false,
};

export type PopQuizLifecycleAction =
    | {type: 'PRESENTED'}
    | {type: 'STOP_SHOWING_CHANGED'; stopShowing: boolean}
    | {type: 'ACCEPTED'; attemptId: string | undefined; questions: PopQuizItem[]}
    | {type: 'COMPLETED'; correctCount: number}
    | {type: 'SNOOZED'}
    | {type: 'SNOOZED_MODAL_CLOSED'}
    | {type: 'CLOSED'};

export function popQuizLifecycleReducer(
    state: PopQuizLifecycleState,
    action: PopQuizLifecycleAction,
): PopQuizLifecycleState {
    switch (action.type) {
        case 'PRESENTED':
            return {...state, isOpen: true};
        case 'STOP_SHOWING_CHANGED':
            return {...state, stopShowing: action.stopShowing};
        case 'ACCEPTED':
            return {
                ...state,
                phase: POP_QUIZ_PHASE.quiz,
                attemptId: action.attemptId,
                questions: action.questions,
            };
        case 'COMPLETED':
            return {...state, phase: POP_QUIZ_PHASE.results, correctCount: action.correctCount};
        case 'SNOOZED':
            return {...state, phase: POP_QUIZ_PHASE.snoozed};
        case 'SNOOZED_MODAL_CLOSED':
            return {...state, isOpen: false};
        case 'CLOSED':
            return {...initialPopQuizLifecycleState};
        default:
            return state;
    }
}
